import { IonButton as IonicIonButton, IonIcon } from '@ionic/react'
import React, { forwardRef } from 'react'
import type { ComponentProps } from 'react'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { IonButton } from './styled'

export type Variant = 'outline' | 'fillWhite' | 'blue'

type ButtonProps = ComponentProps<typeof IonicIonButton> & {
  variant?: Variant
  loading?: boolean
  icon: string
  iconProps?: Omit<ComponentProps<typeof IonIcon>, 'slot' | 'icon'>
  progressBlockSize?: number
}

export const IconButton = forwardRef<HTMLIonButtonElement, ButtonProps>(
  (
    {
      variant = 'outline',
      loading,
      disabled,
      icon,
      iconProps,
      progressBlockSize = 16,
      ...props
    },
    ref,
  ) => {
    return (
      <IonButton
        fill='clear'
        {...props}
        $variant={variant}
        ref={ref}
        $disabled={disabled || loading}
      >
        {loading ? (
          <ProgressBlock
            height={progressBlockSize}
            size={progressBlockSize}
            color='midnightBlue'
          />
        ) : (
          <IonIcon {...iconProps} slot='icon-only' icon={icon} />
        )}
      </IonButton>
    )
  },
)

IconButton.displayName = 'IconButton'
